import { createFileRoute } from '@tanstack/react-router';
import ComingSoonCard from '@/components/Card/ComingSoonCard';
import useDocumentTitle from '@/hooks/useDocumentTitle';
import { stacktraceNS, useTranslation } from '@/lib/i18n';
import { TicketsHeader } from '../-components/TicketsHeader';

/**
 * チケット 概要タブ（STK-020）。
 *
 * 取り急ぎタブの有効化のみ行い、中身は ComingSoonCard（開発中表記）を表示する。
 * ダッシュボード本実装時は issues/_layout/overview と同様の StatCard 構成に
 * 差し替える想定。playbook §3.15（lazy 分離 cascade 回避）に従い 1 ファイル構成
 * （createFileRoute + component 直結）で配置。
 */
export const Route = createFileRoute('/_stacktrace/development-tickets/overview/')({
  component: TicketOverviewPage
});
function TicketOverviewPage() {
  const {
    t: tStacktrace
  } = useTranslation(stacktraceNS);
  useDocumentTitle(tStacktrace('tickets.list.pageTitle'));
  return <div className="flex flex-col h-full">
      <TicketsHeader />
      <div className="flex flex-1 items-center justify-center min-h-0">
        <ComingSoonCard />
      </div>
    </div>;
}